import { Flex, Range, Text } from "src/elements";
import { OTouchedTitle } from "./OTouched";

interface Props {
  title: string;
  description?: string;
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
  isDisabled?: boolean;
  leftLabel?: string;
  rightLabel?: string;

  path?: string;
}

export const RuleRange = ({
  title,
  description,
  min,
  max,
  step,
  value,
  setValue,
  isDisabled,
  leftLabel,
  rightLabel,
  path,
}: Props) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px">
      <OTouchedTitle path={path}>
        <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
          {title}
        </Text>
      </OTouchedTitle>

      {description && (
        <Text variant="small2" textAlign="center" isDisabled={isDisabled}>
          {description}
        </Text>
      )}

      <Range
        min={min}
        max={max}
        step={step}
        value={value}
        setValue={setValue}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        isDisabled={isDisabled}
      />
    </Flex>
  );
};
